import { ADD_USER_ACCOUNT, USER_SESSION_EXPIRED } from "../types";

export default function user(state = {}, action = {}) {
  switch (action.type) {
    case ADD_USER_ACCOUNT: {
      return action.userAccount;
    }
    case USER_SESSION_EXPIRED:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userAccount.js